import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Package, TrendingDown, TrendingUp, AlertCircle, CheckCircle, Search, Download, RefreshCw } from 'lucide-react';
export function FactoryInventory() {
  const inventory = [{
    id: 'INV-001',
    sku: 'SKU-IM-001',
    name: 'Indomie Goreng Special',
    category: 'Finished Goods',
    stock: 5000,
    unit: 'Karton',
    minStock: 1000,
    maxStock: 8000,
    status: 'healthy',
    lastProduction: '11 Okt 2023',
    avgDailyUsage: 250,
    daysRemaining: 20
  }, {
    id: 'INV-002',
    sku: 'SKU-IM-002',
    name: 'Indomie Soto',
    category: 'Finished Goods',
    stock: 3200,
    unit: 'Karton',
    minStock: 1000,
    maxStock: 6000,
    status: 'healthy',
    lastProduction: '10 Okt 2023',
    avgDailyUsage: 180,
    daysRemaining: 17
  }, {
    id: 'INV-003',
    sku: 'SKU-IM-003',
    name: 'Indomie Ayam Bawang',
    category: 'Finished Goods',
    stock: 800,
    unit: 'Karton',
    minStock: 1000,
    maxStock: 5000,
    status: 'low',
    lastProduction: '9 Okt 2023',
    avgDailyUsage: 150,
    daysRemaining: 5
  }, {
    id: 'INV-004',
    sku: 'RM-001',
    name: 'Tepung Terigu',
    category: 'Raw Materials',
    stock: 12000,
    unit: 'Kg',
    minStock: 5000,
    maxStock: 20000,
    status: 'healthy',
    lastProduction: '-',
    avgDailyUsage: 800,
    daysRemaining: 15
  }, {
    id: 'INV-005',
    sku: 'RM-002',
    name: 'Minyak Goreng',
    category: 'Raw Materials',
    stock: 3500,
    unit: 'Liter',
    minStock: 2000,
    maxStock: 8000,
    status: 'healthy',
    lastProduction: '-',
    avgDailyUsage: 200,
    daysRemaining: 17
  }];
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'healthy':
        return 'success';
      case 'low':
        return 'warning';
      case 'critical':
        return 'error';
      default:
        return 'neutral';
    }
  };
  const getStockPercentage = (stock: number, maxStock: number) => {
    return stock / maxStock * 100;
  };
  return <div className="space-y-6" data-id="element-1877">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-1878">
        <div data-id="element-1879">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-1880">
            Inventory Management
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-1881">
            Monitor stok bahan baku dan finished goods
          </p>
        </div>
        <div className="flex gap-2" data-id="element-1882">
          <Button variant="outline" size="sm" icon={<RefreshCw className="w-4 h-4" data-id="element-1884" />} data-id="element-1883">
            Refresh
          </Button>
          <Button variant="primary" size="sm" icon={<Download className="w-4 h-4" data-id="element-1886" />} data-id="element-1885">
            Export Report
          </Button>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-4 gap-4" data-id="element-1887">
        <Card className="p-5 bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200" data-id="element-1888">
          <div className="flex items-center justify-between mb-3" data-id="element-1889">
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-1890">
              <Package className="w-6 h-6 text-white" data-id="element-1891" />
            </div>
            <Badge className="bg-blue-200 text-blue-800 border-0" data-id="element-1892">Total</Badge>
          </div>
          <p className="text-sm text-blue-700 mb-1" data-id="element-1893">Total SKU</p>
          <p className="text-4xl font-bold text-blue-900" data-id="element-1894">5</p>
          <p className="text-xs text-blue-600 mt-1" data-id="element-1895">3 FG + 2 RM</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-green-50 to-green-100 border-green-200" data-id="element-1896">
          <div className="flex items-center justify-between mb-3" data-id="element-1897">
            <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-1898">
              <CheckCircle className="w-6 h-6 text-white" data-id="element-1899" />
            </div>
            <Badge className="bg-green-200 text-green-800 border-0" data-id="element-1900">Good</Badge>
          </div>
          <p className="text-sm text-green-700 mb-1" data-id="element-1901">Healthy Stock</p>
          <p className="text-4xl font-bold text-green-900" data-id="element-1902">4</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-1903">Above minimum</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200" data-id="element-1904">
          <div className="flex items-center justify-between mb-3" data-id="element-1905">
            <div className="w-12 h-12 bg-amber-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-1906">
              <AlertCircle className="w-6 h-6 text-white" data-id="element-1907" />
            </div>
            <Badge className="bg-amber-200 text-amber-800 border-0" data-id="element-1908">
              Alert
            </Badge>
          </div>
          <p className="text-sm text-amber-700 mb-1" data-id="element-1909">Low Stock</p>
          <p className="text-4xl font-bold text-amber-900" data-id="element-1910">1</p>
          <p className="text-xs text-amber-600 mt-1" data-id="element-1911">Need restock</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-violet-50 to-violet-100 border-violet-200" data-id="element-1912">
          <div className="flex items-center justify-between mb-3" data-id="element-1913">
            <div className="w-12 h-12 bg-violet-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-1914">
              <TrendingUp className="w-6 h-6 text-white" data-id="element-1915" />
            </div>
            <Badge className="bg-violet-200 text-violet-800 border-0" data-id="element-1916">
              Value
            </Badge>
          </div>
          <p className="text-sm text-violet-700 mb-1" data-id="element-1917">Total Value</p>
          <p className="text-4xl font-bold text-violet-900" data-id="element-1918">Rp 2.8M</p>
          <p className="text-xs text-violet-600 mt-1" data-id="element-1919">Inventory value</p>
        </Card>
      </div>

      {/* Search */}
      <Card className="p-4" data-id="element-1920">
        <div className="relative" data-id="element-1921">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-1922" />
          <input type="text" placeholder="Cari SKU atau nama produk..." className="w-full pl-10 pr-4 py-2 rounded-lg border border-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500" data-id="element-1923" />
        </div>
      </Card>

      {/* Inventory List */}
      <div className="space-y-4" data-id="element-1924">
        {inventory.map(item => <Card key={item.id} className="p-6" data-id="element-1925">
            <div className="flex items-start gap-6" data-id="element-1926">
              {/* Status Icon */}
              <div className="flex-shrink-0" data-id="element-1927">
                <div className={`w-16 h-16 rounded-xl flex items-center justify-center shadow-lg ${item.status === 'healthy' ? 'bg-gradient-to-br from-green-500 to-green-600' : item.status === 'low' ? 'bg-gradient-to-br from-amber-500 to-amber-600' : 'bg-gradient-to-br from-red-500 to-red-600'}`} data-id="element-1928">
                  <Package className="w-8 h-8 text-white" data-id="element-1929" />
                </div>
              </div>

              {/* Item Info */}
              <div className="flex-1 min-w-0" data-id="element-1930">
                <div className="flex items-start justify-between mb-3" data-id="element-1931">
                  <div data-id="element-1932">
                    <div className="flex items-center gap-3 mb-2" data-id="element-1933">
                      <h3 className="text-xl font-bold text-slate-900" data-id="element-1934">
                        {item.name}
                      </h3>
                      <Badge variant={getStatusColor(item.status)} data-id="element-1935">
                        {item.status === 'healthy' ? 'Healthy' : item.status === 'low' ? 'Low Stock' : 'Critical'}
                      </Badge>
                    </div>
                    <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-1936">
                      <span data-id="element-1937">SKU: {item.sku}</span>
                      <span className="text-slate-400" data-id="element-1938">•</span>
                      <span data-id="element-1939">{item.category}</span>
                      {item.lastProduction !== '-' && <>
                          <span className="text-slate-400" data-id="element-1940">•</span>
                          <span data-id="element-1941">Last production: {item.lastProduction}</span>
                        </>}
                    </div>
                  </div>
                  <div className="text-right" data-id="element-1942">
                    <p className="text-sm text-slate-600 mb-1" data-id="element-1943">Current Stock</p>
                    <p className="text-3xl font-bold text-slate-900" data-id="element-1944">
                      {item.stock.toLocaleString()}
                    </p>
                    <p className="text-sm text-slate-600" data-id="element-1945">{item.unit}</p>
                  </div>
                </div>

                {/* Stock Level Bar */}
                <div className="mb-4" data-id="element-1946">
                  <div className="flex justify-between items-center mb-2" data-id="element-1947">
                    <span className="text-sm font-medium text-slate-700" data-id="element-1948">
                      Stock Level
                    </span>
                    <span className="text-sm text-slate-600" data-id="element-1949">
                      {getStockPercentage(item.stock, item.maxStock).toFixed(1)}
                      % of capacity
                    </span>
                  </div>
                  <div className="relative w-full h-3 bg-slate-200 rounded-full overflow-hidden" data-id="element-1950">
                    {/* Min stock indicator */}
                    <div className="absolute h-full border-l-2 border-amber-500" style={{
                  left: `${item.minStock / item.maxStock * 100}%`
                }} data-id="element-1951"></div>
                    {/* Current stock */}
                    <div className={`h-full rounded-full ${item.status === 'healthy' ? 'bg-gradient-to-r from-green-500 to-green-600' : item.status === 'low' ? 'bg-gradient-to-r from-amber-500 to-amber-600' : 'bg-gradient-to-r from-red-500 to-red-600'}`} style={{
                  width: `${getStockPercentage(item.stock, item.maxStock)}%`
                }} data-id="element-1952"></div>
                  </div>
                  <div className="flex justify-between text-xs text-slate-500 mt-1" data-id="element-1953">
                    <span data-id="element-1954">Min: {item.minStock.toLocaleString()}</span>
                    <span data-id="element-1955">Max: {item.maxStock.toLocaleString()}</span>
                  </div>
                </div>

                {/* Details Grid */}
                <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-1956">
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-1957">
                    <p className="text-xs text-slate-600 mb-1" data-id="element-1958">
                      Avg Daily Usage
                    </p>
                    <p className="text-lg font-bold text-slate-900" data-id="element-1959">
                      {item.avgDailyUsage} {item.unit}
                    </p>
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-1960">
                    <p className="text-xs text-slate-600 mb-1" data-id="element-1961">
                      Days Remaining
                    </p>
                    <p className={`text-lg font-bold ${item.daysRemaining > 10 ? 'text-green-600' : item.daysRemaining > 5 ? 'text-amber-600' : 'text-red-600'}`} data-id="element-1962">
                      ~{item.daysRemaining} days
                    </p>
                  </div>
                  <div className="p-3 bg-slate-50 rounded-lg" data-id="element-1963">
                    <p className="text-xs text-slate-600 mb-1" data-id="element-1964">Status</p>
                    <p className={`text-lg font-bold ${item.status === 'healthy' ? 'text-green-600' : item.status === 'low' ? 'text-amber-600' : 'text-red-600'}`} data-id="element-1965">
                      {item.status === 'healthy' ? 'Sufficient' : item.status === 'low' ? 'Need Restock' : 'Critical'}
                    </p>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex gap-2 pt-4 border-t border-slate-200" data-id="element-1966">
                  {item.status === 'low' && <Button variant="primary" size="sm" icon={<TrendingUp className="w-4 h-4" data-id="element-1968" />} data-id="element-1967">
                      Schedule Production
                    </Button>}
                  <Button variant="outline" size="sm" data-id="element-1969">
                    View History
                  </Button>
                  <Button variant="outline" size="sm" data-id="element-1970">
                    Adjust Stock
                  </Button>
                </div>
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
}